module.exports = __webpack_public_path__ + "img/electric-mining-drill-E.eaf53a0a.png";